import { BRIDGE_MESSAGE_TYPE, EVENTS_TYPE } from "client/services/iframe-events-bridge-service/iframe-events-bridge-constants";
import { isRunningInClient } from "services/dom-utils-service";
import { isInIframe } from "utils/iframe-utils";
export const sendEventUsingBridge = (eventType, payload, explicitTargetOrigin)=>{
    if (!isRunningInClient()) {
        return false;
    }
    const targetOrigin = explicitTargetOrigin !== null && explicitTargetOrigin !== void 0 ? explicitTargetOrigin : window.location.origin;
    if (!targetOrigin) {
        return false;
    }
    window.parent.postMessage({
        type: BRIDGE_MESSAGE_TYPE,
        eventType,
        payload
    }, targetOrigin);
    return true;
};
export const notifyParentLoadingScreenShow = ()=>{
    if (!isInIframe()) {
        return;
    }
    sendEventUsingBridge(EVENTS_TYPE.LOADING_SCREEN_SHOW, {});
};
export const notifyParentLoadingScreenHide = ()=>{
    if (!isInIframe()) {
        return;
    }
    sendEventUsingBridge(EVENTS_TYPE.LOADING_SCREEN_HIDE, {});
};
export const notifyParentRedirect = (redirectUrl)=>{
    if (!isInIframe() || typeof redirectUrl !== "string" || redirectUrl === "") {
        return;
    }
    sendEventUsingBridge(EVENTS_TYPE.PARENT_REDIRECT, {
        redirectUrl
    });
};
